// extracted by mini-css-extract-plugin
module.exports = {"accentButton":"app-button_accentButton_Q4Y2m","defaultButton":"app-button_defaultButton_3gprB"};